import { Button, Typography } from '@breetometer/components';
import { PadlockIcon } from 'BreetAssets';
import { useModalApi } from 'BreetHooks';
import { useCallback } from 'react';
import { useNavigate } from 'react-router';

export const DialogTwoFaWarning = () => {
	const navigate = useNavigate();

	const { closeModalDirect } = useModalApi();

	const goTo2faSettings = useCallback(() => {
		navigate('/settings/security/mfa-factor-authentication')
			?.then(() => {
				closeModalDirect('twoFAWarning');
			})
			.catch(console.error);
	}, [navigate, closeModalDirect]);

	return (
		<div className='two-fa-warning bg-primary-500'>
			<PadlockIcon variant='2fa' />

			<Typography
				as='h4'
				className='color-neutral-50'
			>
				Protect Your Account
			</Typography>

			<Typography className='color-primary-100'>
				You have a high wallet balance. Enable extra protection on your account to keep your funds safer and prevent unauthorized
				access.
			</Typography>

			<Button onClick={goTo2faSettings}>Secure My Account</Button>
		</div>
	);
};
